import type { ConversationMessage } from "@mirage/service-conversation/types";

export function parseMessageJSON(message: ConversationMessage) {
  // TODO: are there other fields that we should be checking here to make sure it is a markdown draft?
  if (
    message.messageType.case === "assistantMessage" &&
    message.jsonContent?.content?.length
  ) {
    return {
      type: "markdownDraft",
      content: message.jsonContent?.content,
    };
  }
  return undefined;
}
